import axios from 'axios'
import { WORDPRESS_API_BASE } from 'utility/endpoints'

const Axios = axios.create({
	baseURL: WORDPRESS_API_BASE,
	timeout: 50000,
})

export default Axios
